import { useMemo } from 'react';

import { useIsApiEligiblePlan } from '~/hooks/useIsApiEligiblePlan';
import { useCurrentWorkspace } from '~/providers/CurrentWorkspaceProvider';
import { useWorkspaceRolesContext } from '~/providers/WorkspaceRolesProvider';

export const useIsApiAdmin = () => {
  const { currentWorkspace } = useCurrentWorkspace();
  const { data: roles } = useWorkspaceRolesContext();
  const { isApiEligiblePlan } = useIsApiEligiblePlan();

  const isApiAdmin = useMemo(() => {
    const adminRoleIds = roles?.filter((role) => role.isAdmin).map((role) => role.id);

    return isApiEligiblePlan && (adminRoleIds?.includes(currentWorkspace?.roleId ?? '') ?? false);
  }, [currentWorkspace, isApiEligiblePlan, roles]);

  return { isApiAdmin };
};
